import { render, staticRenderFns } from "./ShoppableModal.vue?vue&type=template&id=0e8e4c49"
import script from "./ShoppableModal.vue?vue&type=script&lang=js"
export * from "./ShoppableModal.vue?vue&type=script&lang=js"
import style0 from "./ShoppableModal.vue?vue&type=style&index=0&id=0e8e4c49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports